export default function ReportRowHeader(props)
{
    return(<>
            <tr className="reportRowHeader">
                <td colSpan={(props.financials.length*2)+1}>{props.header}</td>
            </tr>
    </>);
}
